import type { ThemeConfig } from "antd";

import { GLOW_TOKENS } from "./tokens";

/**
 * Build the antd ThemeConfig for the Glow Price admin console.
 *
 * Returns a fresh object so callers can spread/override safely. All values
 * are derived from {@link GLOW_TOKENS}; do not hard-code palette values here.
 */
export function buildGlowTheme(): ThemeConfig {
  const { colors } = GLOW_TOKENS;

  return {
    token: {
      colorPrimary: colors.primary,
      colorBgLayout: colors.bgLayout,
      colorBgContainer: colors.bgContainer,
      colorBorder: colors.border,
      colorText: colors.textPrimary,
      colorTextSecondary: colors.textSecondary,
      colorSuccess: colors.success,
      colorWarning: colors.warning,
      colorError: colors.error,
      fontFamily: GLOW_TOKENS.fontFamily,
      borderRadius: GLOW_TOKENS.borderRadius,
      borderRadiusLG: GLOW_TOKENS.borderRadiusLG,
      controlHeight: GLOW_TOKENS.controlHeight,
      boxShadow: GLOW_TOKENS.boxShadow,
      boxShadowSecondary: GLOW_TOKENS.boxShadowSecondary,
    },
    components: {
      Layout: {
        headerBg: colors.siderBg,
        siderBg: colors.siderBg,
        headerColor: colors.siderText,
      },
      Menu: {
        darkItemBg: colors.siderBg,
        darkItemSelectedBg: colors.primary,
        darkItemHoverBg: colors.siderHoverBg,
      },
      Table: {
        headerBg: colors.tableHeaderBg,
        rowHoverBg: colors.tableRowHoverBg,
        headerSplitColor: colors.border,
      },
      Tag: {
        borderRadiusSM: 6,
      },
      Card: {
        borderRadiusLG: 12,
      },
      Button: {
        fontWeight: 500,
      },
    },
  };
}

export { GLOW_TOKENS } from "./tokens";
export default buildGlowTheme;
